import { RESERVATION_TYPE } from '@/entities/reservation'

/**
 * 제휴 예약 플로우(entities/reservation의 RESERVATION_TYPE)를 통해 정비소 상세에
 * 진입하면 전부 제휴 전용 화면으로 분기한다 (WEB-5901).
 * 제휴 퍼널은 앱 설치 없는 빠른 웹 예약이 목적이라, 상세페이지의 쿠폰·상품·앱 설치
 * 유도를 전부 숨기고 예약 플로우로만 안내한다.
 * 새 제휴는 entities/reservation의 RESERVATION_TYPE에 추가하면 자동으로 여기도 적용된다.
 */
const VALID_RESERVATION_TYPES: readonly string[] =
  Object.values(RESERVATION_TYPE)

export const isPlaceDetailPartnerReservationType = (
  type?: string | null
): boolean => !!type && VALID_RESERVATION_TYPES.includes(type)

/** 제휴 유입 CTA 버튼 문구. 클릭 시 앱 설치 대신 탭을 닫고 예약 화면으로 돌아간다. */
export const PLACE_DETAIL_PARTNER_CTA_TEXT = '예약하러 가기'
